// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"styles-module--mainLayout--1N8I6"};